import React, { useEffect } from "react";
import { Container, } from "react-bootstrap";
import { connect } from "react-redux";
import { getBrandApi, deleteBrandApi, updateBrandApi } from "./Brand.action";
import { baseURL, headers } from "../../../../../global/api";
import { setHeading } from "../../../accounts/account.actions";
import { PDFHeader } from "../../../../../global/globalFunctions";
import MaterialSize from "material-table";
import jsPDF from "jspdf";


const ViewBrand = (props) => {

  useEffect(() => {
    props.setHeading("Brand List");
  }, []);

  return (
    <>
      <Container fluid>
        <MaterialSize
          title="Brand List"
          columns={[
            { title: 'S.No', field: 'sequenceNumber', editable: 'never' },
            { title: 'Customer', field: 'customerDetails.name', editable: 'never' },
            { title: "Brand Name", field: "brandName" },
            { title: "Brand Description", field: "brandDetails" },
            { title: "Created By", field: "userDetails.userName", editable: 'never' },
          ]}
          data={(query) =>
            new Promise((resolve, reject) => {
              let url = `${baseURL}/brand?`;
              url += "limit=" + query.pageSize;
              url += "&page=" + (query.page);
              url += "&search=" + query.search;
              fetch(url, {
                method: "GET",
                headers: headers,
              }).then((response) => response.json()).then((result) => {
                resolve({
                  data: result.data,
                  page: result.page,
                  totalCount: result.total_results,
                });
              });
            })
          }
          options={{
            actionsColumnIndex: -1,
            exportButton: true,
            exportAllData: true,
            paging: true,
            pageSize: 50,
            emptyRowsWhenPaging: false,
            pageSizeOptions: [50, 100, 150, 200],
            headerStyle: {
              position: "sticky",
              top: 0,
              color: "#00BBBB",
              fontWeight: "550",
              onRowAdd: "none",
              whiteSpace: 'nowrap',
            },
            rowStyle: {
              whiteSpace: 'nowrap',
            },
            cellStyle: {
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            },
            exportPdf: (columns, data) => {
              const unit = "pt";
              const size = "A4";
              const orientation = "potrait";
              const doc = new jsPDF(orientation, unit, size);
              PDFHeader(doc, "Brand Details");

              const columnTitles = columns.map(columnDef => columnDef.title);
              const pdfData = data.map((elt) => [
                elt.sequenceNumber,
                elt.customerDetails.name,
                elt.brandName,
                elt.brandDetails,
                elt.userDetails.userName,
              ]);
              let content = {
                startY: 120,
                startX: 5,
                head: [columnTitles],
                body: pdfData,
                headStyles: { fillColor: "#2980ba", font: 'Amiri', fontSize: 10 },
                styles: { fontSize: 9 },
                theme: "grid",
              };

              doc.setFontSize(11)
              doc.setFont("Times New Roman", "Normal")
              doc.autoTable(content);

              doc.setProperties({ title: 'Brand Details' })
              doc.output('dataurlnewwindow')
            },
          }}
          editable={{
            onRowUpdate: (newData, oldData) => new Promise((resolve) => {
              setTimeout(() => {
                resolve();
                props.updateBrandApi(newData, oldData);
              }, 600);
            }),
            onRowDelete: (oldData) => new Promise((resolve) => {
              setTimeout(() => {
                resolve();
                props.deleteBrandApi(oldData._id);
              }, 600);
            }),
          }}
        />
      </Container>
    </>
  );
};
const mapDispatchToProps = (dispatch) => {
  return {
    getBrandApi: () => dispatch(getBrandApi()),
    deleteBrandApi: (id) => dispatch(deleteBrandApi(id)),
    updateBrandApi: (newData, oldData) => dispatch(updateBrandApi(newData, oldData)),
    setHeading: (data) => dispatch(setHeading(data)),
  };
};
const mapStateToProps = (state, ownProps) => ({
  brandDataList: state.brandReducer.brandDataList,
  isFetchingBrand: state.brandReducer.isFetchingBrand,
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewBrand);
